import { atom } from "jotai";

export const isUserUploadingAtom = atom<boolean>(false);
export const videosPlayingAtom = atom<string[]>([]);
export const isUserWatchingAtom = atom(
  get => get(videosPlayingAtom).length > 0
);

export type SessionActivity = {
  phase: "active" | "warning" | "idle" | "resuming";
  deadline: number | null;
};

export const sessionActivityAtom = atom<SessionActivity>({
  phase: "active",
  deadline: null
});
